import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function PublicOnly({ children }) {
    const { isAuthenticated } = useAuth();
    const loc = useLocation();
    if (isAuthenticated) return <Navigate to="/dashboard" state={{ from: loc }} replace />;
    return children;
}
